import React from 'react';
import joi from 'joi-browser';
import { Form, Row, Col } from 'antd';
import { connect } from 'react-redux';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';
import PlaceCard from '../Places/components/PlaceCard';
import InfoItem from '../../components/InfoItem';
import IsApproved from '../../components/IsApproved';
import { getById, save, resetState, resetSuccessSave } from '../../modules/cards';

class CardForm extends EditForm {
  validationSchema = joi.object({
    id: joi.number().default(null),
    name: joi.string().trim().required(),
    logo: joi.object().when('id', { is: null, then: joi.required() }),
    delete_logo: joi.boolean().default(false),
    description: joi.string().trim().required(),
  });

  styles = {
    ...this.styles,
    uploadForm: {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    },
  };

  static getDerivedStateFromProps(props) {
    const { data } = props;

    if (data && data.id) {
      return { data };
    }

    return null;
  }

  render() {
    const { data, successSave, error } = this.props;

    return (
      <Layout>
        <Form onSubmit={this.onSubmit}>
          {this.renderFormActions('Save')}
          {successSave && this.renderSuccessAlert('Card has been successfully saved.')}
          {error && this.renderErrorAlert(error)}
          <div className="container-md">
            <Row gutter={16}>
              <Col md={24} lg={14}>
                <InfoItem label="Status"
                          value={<IsApproved isApproved={data.approved} approve />}
                          labelSpan={6}
                          valueSpan={18} />
                <div className="mb-minus-3">
                  {this.renderUpload('logo',
                    '.jpg, .png, .jpeg',
                    true,
                    'Upload Photo',
                    false,
                    this.styles.uploadForm,
                  'upload-card-logo')}
                </div>
                {this.renderInput('name', true, 'Name', null, null, 1)}
                {this.renderInput('description', true, 'Description', null, null, 2)}
              </Col>
              <Col md={24} lg={10}>
                <h3>Place</h3>
                <PlaceCard place={data.place} />
              </Col>
            </Row>
          </div>
        </Form>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.cards,
  }),
  {
    getById, onSubmit: save, resetState, resetSuccessSave,
  })(CardForm);



// WEBPACK FOOTER //
// ./src/containers/Cards/CardForm.js